import { AppstoreAddOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import { type LeadActivityUpdateNodeType, nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import LeadActivityUpdateMenu from '../../components/Nodes/LeadActivityUpdateMenu';
import { type TriggerNodeReturnProps } from './useTriggerNodeConfig';

export default function useLeadActivityUpdate(node: NodeProps<LeadActivityUpdateNodeType>): TriggerNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.LeadActivityUpdateNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <LeadActivityUpdateMenu node={node} />, [node]);

  return {
    icon: AppstoreAddOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
